angular
  .module("AccountingBoxApp")
  .controller("ReportingTAccountCtrl", function(
    $scope,
    $http,
    $state,
    FileUploader,
    LoopBackAuth,
    Journal,
    Account,
    Rapporting,
    $rootScope
  ) {
    $scope.order = {
      by: "date",
      reverse: false,
      filter: ""
    };

    var vm = this;
    vm.search = "";

    vm.year = "open";

    vm.displayYears = $rootScope.displayYears.filter(function(option) {
      return option.value !== "all";
    });

    vm.dates = {
      startDate: moment()
        .year($rootScope.currentYear())
        .startOf("year"),
      endDate: moment()
      //.endOf("year")
    };

    vm.dataChanged = function() {
      if (!vm.dates.startDate) return;
      var beginDate = vm.dates.startDate.toDate();
      var endDate = vm.dates.endDate.toDate();

      if (!vm.accountFrom) {
        return;
      }
      if (!vm.accountTo) {
        vm.accountTo = vm.accountFrom;
      }
      vm.loading = true;

      Rapporting.tAccounts(
        {
          beginDate: beginDate,
          endDate: endDate,
          accountFrom: vm.accountFrom.accountNumber,
          accountTo: vm.accountTo.accountNumber
        },
        function(result) {
          vm.tAccounts = result.tAccounts;
          vm.loading = false;
        }
      );
    };
    //Watch for date changes
    $scope.$watch(
      "rta.dates",
      function(newDate) {
        vm.dataChanged();
      },
      false
    );

    vm.dataChanged();

    Account.findApplicable(function(accounts) {
      vm.accounts = accounts;
    });

    $scope.accountGroup = function(item) {
      return item.subCategory.description;
    };

    vm.toTransaction = function(journalLine) {
      Journal.findById({ id: journalLine.journalId }, function(journal) {
        if (!journal) {
          return alert("Journaal niet gevonden");
        }
        var url;
        if (journal.transactionType === "BankTransaction") {
          url = $state.href("app.company.bank.transactions", {id: journal.transaction.bankAccountId});
          url =`${url}?bankTransactionId=${journal.transaction.id}`;
        } else {
          var to = journal.transactionType.toLowerCase() + "s";
          if (journal.transactionType.toLowerCase() === "journalentry") {
            to = "journalEntries";
          }
          url = $state.href("app.company.edit." + to, {
            id: journal.transactionId
          });
        }

        window.open(url, "_blank");
      });
    };

    vm.today = function() {
      return moment().format("L");
    };
  });
